import React, {  useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Link } from 'react-router-dom';
import { TbSettingsSearch } from "react-icons/tb";
import { FaBullhorn, FaShareAlt, FaEnvelope } from "react-icons/fa";
import Imac from '../images/macbook_.webp';
import IPhone10 from '../images/iphone10.webp';
import Comp_Screen from '../images/google-search-yokai-software.webp'; 
import Comp_Screen2 from '../images/yokia_Screenshot.png';
import Comp_Screen3 from '../images/social_media2.PNG';
import IPhone11 from '../images/iphone11.webp';
import ImacScreen from '../images/imac_screen.webp';  
import './MarketingStackModule.css';
import './index2.css';

const MarketingStackModule = () => {


  const stickyRef8 = useRef(null);
  const overlayRef8 = useRef(null);
  const ref = useRef(null);
  /*const inView = useInView(ref, { once: true, amount: 0.25 });*/
  const inView = useInView(ref, { once: true, amount: 0.15, margin: "-10% 0px -10% 0px" });

  const container = {
    hidden: { opacity: 0, y: 18 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: "easeOut", staggerChildren: 0.12 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 14 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
  };

  useEffect(() => {

    
      const handleScroll8 = () => {

        

      if (!stickyRef8 || !overlayRef8 || !stickyRef8.current || !overlayRef8.current) return;
      const stickyRect8 = stickyRef8.current.getBoundingClientRect();
      const overlayRect8 = overlayRef8.current.getBoundingClientRect();
    
      if (stickyRect8.top <= 0 && stickyRect8.bottom > overlayRect8.height) {
        overlayRef8.current.style.position = 'fixed';
        overlayRef8.current.style.top = '0';
        /*overlayRef.current.style.width = `${stickyRef.current.offsetWidth}px`;*/
      } else if (stickyRect8.bottom <= overlayRect8.height) {
        overlayRef8.current.style.position = 'absolute';
        overlayRef8.current.style.top = `${stickyRect8.height - overlayRect8.height}px`;
      } else {
        overlayRef8.current.style.position = 'absolute';
        overlayRef8.current.style.top = '0';
      }
      };
    
      window.addEventListener('scroll', handleScroll8, { passive: true });
      handleScroll8();
      return () => {
      window.removeEventListener('scroll', handleScroll8);
      };
    }, []);

  return (
    <div className="module" id="moduleMarketingStack" ref={ref}>
      <div id="mstack_div1">
        
        <div className="sticky-element-container5">
          <div ref={stickyRef8} className="background-div2_2">
            <div ref={overlayRef8} className="overlay-container5">
              <motion.div
                id="mstack_overlayText"
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
                variants={container}
              >
                <motion.h1 variants={item}>Digital Growth Services</motion.h1>
                <motion.h3 variants={item}>
                  SEO, paid ads, social credibility, and outbound email — aligned as one system.
                </motion.h3>
              </motion.div>
            </div>

            <div></div>
          </div>
        </div>

        {/* Cards */}
        <div id="mstack_div2">
          <motion.div
            id="mstack_cards"
             initial="visible"
            animate="visible"
            variants={container}
          >
            {/* 1) SEO */}
            <motion.div className="mod4_sub_div2" variants={item}>
              <Link to="/seo" className="card-link" onClick={() => window.scrollTo(0, 0)}>
                <div className="mstack_icon"><img src={Imac} alt="Imac" className="Imac" /></div>
                <h2>SEO &amp; Google Ranking</h2>
                <p className="mstack_lead">
                  Rank on Google for your top keywords dominate your industry and location using our SEO ranking strategy
                </p>
                <ul className="mstack_list">
                  <li>Full Site Audit &amp; Task List</li>
                  <li>Daily Keyword Monitoring</li>
                  <li>Content Production</li>
                  <li>On-Page Technical SEO</li>
                  <li>Backlinks</li>
                </ul>
              </Link>
            </motion.div>

            {/* 2) Ads */}
            <motion.div className="mod4_sub_div2" variants={item}>
              <Link to="/social_media_marketing" className="card-link" onClick={() => window.scrollTo(0, 0)}>
                <div className="mstack_icon">
                  <div className="deviceWrap phone10">
                    <img src={IPhone10} alt="IPhone10" className="deviceImg" />
                    <div className="screen-content2">
                      <img src={Comp_Screen} alt="Screenshot inside phone screen" />
                    </div>
                  </div>
                </div>
                <h2>Facebook, Google &amp; Instagram Ads</h2>
                <p className="mstack_lead">
                  Web design and social media marketing needs to be strategized from the start or it will not work — follow the numbers to success
                </p>
                <ul className="mstack_list">
                  <li>Ads Strategy &amp; Management</li>
                  <li>Placement Allocation &amp; Budgets</li>
                  <li>Competitor Analysis &amp; Tracking</li>
                  <li>Ad Creation &amp; Design</li>
                  <li>Monthly ROI Reports</li>
                </ul>
              </Link>
            </motion.div>

            {/* 3) Social */}
            <motion.div className="mod4_sub_div2" variants={item}>
              <Link to="/social_media_marketing" className="card-link" onClick={() => window.scrollTo(0, 0)}>
                <div className="mstack_icon">
                  <div className="deviceWrap phone11">
                    <img src={IPhone11} alt="IPhone11" className="deviceImg2" />
                    <div className="screen-content3">
                      <img src={Comp_Screen3} alt="Screenshot inside phone screen" />
                    </div>
                  </div>
                </div>
                <h2>Social Media Management</h2>
                <p className="mstack_lead">
                  Gain trust and exposure by setting up your social media profiles to show who you are and what you do at the highest level
                </p>
                <ul className="mstack_list">
                  <li>Strategy &amp; Design</li>
                  <li>Image &amp; Video Templates</li>
                  <li>Content Creation &amp; Posting</li>
                  <li>Instagram, Facebook, YouTube, LinkedIn</li>
                  
                </ul>
              </Link>
            </motion.div>

            {/* 4) Email */}
            <motion.div className="mod4_sub_div2" variants={item}>
              <Link to="/social_media_marketing" className="card-link" onClick={() => window.scrollTo(0, 0)}>
                <div className="mstack_icon">
                  <div className="deviceWrap_Imac">
                     <img src={ImacScreen} alt="ImacScreen" className="Imac" />
                     <div className="screen-content4">
                      <img src={Comp_Screen2} alt="Screenshot inside phone screen" />
                    </div>
                  </div>
                  </div>
                  
                <h2>Email Marketing</h2>
                <p className="mstack_lead">
                  Use AI to create lead lists and send customized personal emails to potential clients or current customers to keep them engaged.
                </p>
                <ul className="mstack_list">
                  <li>AI Lead List Generation</li>
                  <li>Proven Templates &amp; Scripts</li>
                  <li>CRM &amp; Software Syncing</li>
                  <li>Monthly Reports</li>
                </ul>
              </Link>
            </motion.div>

          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default MarketingStackModule;